import { LeaseColumns, CompanyColumns, LeaseSections, CompanySections } from '@miq/catalog';

// Occupier Type columns/sections hidden from the Lease and Company filter catalog
export const OCCUPIER_TYPE_COLUMNS = [
  LeaseColumns.LeaseLeaseCompDetails_OccupierType,
  CompanyColumns.BusinessClassification_OccupierType,
  LeaseColumns.LeaseCompany_OccupierType,
];
export const OCCUPIER_TYPE_SECTION_IDS: number[] = [
  LeaseSections.LeaseCompDetails,
  CompanySections.BusinessClassification,
  LeaseSections.Companies,
];
